export const PAYMENT_METHOD_VISA = 'VISA';
export const PAYMENT_METHOD_EC = 'EC';
export const PAYMENT_METHOD_AX = 'AX';
export const PAYMENT_METHOD_DINERS_CLUB = 'DC';
export const PAYMENT_METHOD_SEPA = 'SEPA';
export const PAYMENT_METHOD_INVOICE = 'INVOICE';
export const PAYMENT_METHOD_SOFORT = 'INSTANTBANKTRANSFERLIGHT';
export const PAYMENT_METHOD_PAYPAL = 'PAYPAL';
export const PAYMENT_METHOD_PAYPALLIGHT = 'PAYPALLIGHT';